module.exports = __webpack_public_path__ + "static/img/usercenter@2x.afc96991.png";